import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import DashboardDto from "../classes/dtos/portalmodule/DashboardDto";
import DashboardDetailDto from "../classes/dtos/portalmodule/DashboardDetailDto";
import DashboardComponentDto from "../classes/dtos/portalmodule/DashboardComponentDto";

const PortalApi = {

    GetDashboardsAsync: async function (): Promise<ProcessingResult<DashboardDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Portal/GetDashboards", {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(
                data.dashboards.map((e: any) => new DashboardDto(e.id, e.name))
            );
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetDashboardAsync: async function (id: number): Promise<ProcessingResult<DashboardDetailDto>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Portal/GetDashboard?id=" + id, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(
                new DashboardDetailDto(data.id, data.name, data.components.map((e: any) => new DashboardComponentDto(e.id, e.name, e.type)))
            );
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetComponentChartAsync: async function (dashboardComponentId: number): Promise<ProcessingResult<string>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Portal/GetComponentChart?dashboardComponentId=" + dashboardComponentId, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.html);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateDashboardAsync: async function (name: string): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Portal/CreateDashboard", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'name': name
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.id);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdateDashboardAsync: async function (dashboardId: number, name: string): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Portal/UpdateDashboard", {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'dashboardId': dashboardId,
                'name': name
            })
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteDashboardAsync: async function (dashboardId: number): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Portal/DeleteDashboard?id=" + dashboardId, {
            method: "DELETE",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default PortalApi;
